<template>
    <div class="min-h-screen h-full w-full bg-true-gray-900 pb-20">
        <div class=" max-w-7xl mx-auto">
            <div class="p-4 lg:p-8">
                <div>
                    <button @click="handleBackNavigation()" type="button"
                        class="w-auto px-6 text-center whitespace-nowrap text-base rounded-md border-true-gray-400 border-2 py-3 text-base font-semibold text-true-gray-400 hover:bg-true-gray-700 hover:bg-opacity-20 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-true-gray-500">
                        &larr; {{ isAdminPurchase ? 'Back to Users' : 'Back to Your Reviewers' }}
                    </button>
                </div>
                <!-- Admin Purchase Banner -->
                <div v-if="isAdminPurchase"
                    class="mt-4 p-4 bg-blue-900 bg-opacity-50 border border-blue-400 rounded-lg">
                    <p class="text-blue-300 font-semibold text-center">
                        Buying as <span class="text-blue-100">{{ userInfo?.email || 'Loading...' }}</span>
                    </p>
                </div>
                <div class="max-w-[85rem] mt-12 sm:px-6 lg:px-8 mx-auto">

                    <div class="text-center max-w-4xl mx-auto mt-6 ">
                        <div id="limited-time-offers" class="sr-only"></div>
                        <h2 class="text-base font-semibold tracking-wider text-yellow-400 uppercase">
                            Pricing
                        </h2>
                        <h1 class="text-2xl sm:text-3xl lg:text-4xl text-true-gray-300 font-bold">
                            Bundles
                        </h1>
                        <!-- <p class="mt-5 mx-auto text-base sm:text-xl text-true-gray-500">
                        Get access to the Skilltech Reviewer bundles at discounted rates for a limited time. Our goal is to make high-quality exam preparation accessible to everyone anytime, anywhere.
                    </p> -->
                        <p
                            class="mt-5  mx-auto text-base sm:text-xl text-green-300 font-semibold bg-green-900 bg-opacity-50 px-4 py-2 rounded-lg border border-green-400">
                            Limited Time Offer! Ends December 31, 2025xxx 🎄
                        </p>
                    </div>

                    <!-- End Title -->

                    <div class="relative xl:w-full xl:mx-auto mt-6 sm:mt-12">
                        <!-- Grid -->
                        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 ">
                            <div class="order-2 lg:order-1">
                                <!-- Card -->
                                <div
                                    class="p-4 relative z-10 px-6 pb-4 pt-5 bg-true-gray-900 border border-true-gray-700 rounded-xl md:p-10">
                                    <h3 class="mt-8 sm:mt-4 md:mt-2 text-xl font-bold text-true-gray-300">
                                        CAAP License Bundle</h3>
                                    <div class="text-sm text-true-gray-500">
                                        Everything you need to pass your CAAP License exams.
                                    </div>
                                    <!-- <span
                                    class="font-semibold absolute top-0 right-0 rounded-tr-xl rounded-bl-xl rounded-es-xl text-sm font-medium bg-true-gray-800 text-white py-1.5 px-3">
                                    Most Popular! Save up ₱1,000!
                                </span> -->
                                    <span
                                        class="font-semibold absolute top-0 right-0 rounded-tr-xl rounded-bl-xl rounded-es-xl text-sm font-medium bg-true-gray-800 text-white py-1.5 px-3">
                                        Most Popular! Save up to ₱2,000!
                                    </span>

                                    <!-- <div class="mt-5">
                                    <span class="text-6xl font-bold text-true-gray-300">
                                        ₱{{ caapLicenseBundlePrice }}
                                    </span>
                                </div> -->
                                    <div class="mt-5 flex flex-row items-end">
                                        <span class="text-4xl sm:text-6xl font-bold text-true-gray-300">₱{{
                                            caapLicenseBundlePrice }}</span>
                                    </div>

                                    <div
                                        class="mt-2 grid grid-cols-2 gap-y-2 py-4 first:pt-0 last:pb-0 sm:gap-x-6 sm:gap-y-0">
                                        <!-- List -->
                                        <ul class="space-y-2 text-sm sm:text-base">
                                            <li class="flex gap-x-3">
                                                <span
                                                    class="mt-0.5 w-5 h-5 flex justify-center items-center rounded-full bg-yellow-900 text-yellow-400">
                                                    <svg class="shrink-0 w-4 h-4" xmlns="http://www.w3.org/2000/svg"
                                                        width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                        stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                        stroke-linejoin="round">
                                                        <polyline points="20 6 9 17 4 12"></polyline>
                                                    </svg>
                                                </span>
                                                <span class="text-true-gray-300">
                                                    CAAP 101
                                                </span>
                                            </li>

                                            <li class="flex gap-x-3">
                                                <span
                                                    class="mt-0.5 w-5 h-5 flex justify-center items-center rounded-full bg-yellow-900 text-yellow-400">
                                                    <svg class="shrink-0 w-4 h-4" xmlns="http://www.w3.org/2000/svg"
                                                        width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                        stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                        stroke-linejoin="round">
                                                        <polyline points="20 6 9 17 4 12"></polyline>
                                                    </svg>
                                                </span>
                                                <span class="text-true-gray-300">
                                                    CAAP Knowledge
                                                </span>
                                            </li>

                                        </ul>
                                        <!-- End List -->

                                        <!-- List -->
                                        <ul class="space-y-2 text-sm sm:text-base">
                                            <li class="flex gap-x-3">
                                                <span
                                                    class="mt-0.5 w-5 h-5 flex justify-center items-center rounded-full bg-yellow-900 text-yellow-400">
                                                    <svg class="shrink-0 w-4 h-4" xmlns="http://www.w3.org/2000/svg"
                                                        width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                        stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                        stroke-linejoin="round">
                                                        <polyline points="20 6 9 17 4 12"></polyline>
                                                    </svg>
                                                </span>
                                                <span class="text-true-gray-300">
                                                    CAAP Practical
                                                </span>
                                            </li>

                                            <li class="flex gap-x-3">
                                                <span
                                                    class="mt-0.5 w-5 h-5 flex justify-center items-center rounded-full bg-true-gray-800 text-true-gray-500">
                                                    <svg class="shrink-0 w-4 h-4" xmlns="http://www.w3.org/2000/svg"
                                                        width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                        stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                        stroke-linejoin="round">
                                                        <path d="M18 6 6 18"></path>
                                                        <path d="m6 6 12 12"></path>
                                                    </svg>
                                                </span>
                                                <span class="text-true-gray-300">
                                                    MTP Entrance
                                                </span>
                                            </li>

                                        </ul>
                                        <!-- End List -->
                                    </div>

                                    <div
                                        class="mt-5 flex flex-col space-y-4 sm:space-y-0 sm:flex-row first:pt-0 last:pb-0">
                                        <div class="flex-1">
                                            <p class="text-sm text-true-gray-500">3-month access per
                                                reviewer.</p>
                                            <p class="text-sm text-true-gray-500">Activate anytime when
                                                you're ready to start.</p>
                                        </div>

                                        <div v-if="canPurchaseFullLicenseBundle && !isInitializing" class="sm:ml-4">
                                            <button :disabled="!canPurchaseFullLicenseBundle"
                                                @click="openPurchaseModal('CAAP License Bundle')"
                                                class="mb-3 sm:mb-0 px-8 w-full text-center whitespace-nowrap text-base rounded-md py-3 text-base font-semibold text-true-gray-300 border border-true-gray-700  hover:bg-true-gray-800 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-true-gray-500">
                                                Get Access
                                            </button>
                                        </div>
                                    </div>

                                    <div v-if="!canPurchaseFullLicenseBundle && !isInitializing"
                                        class="text-sm text-green-500 border border-green-500 rounded-md p-2 mt-4 text-left">
                                        You already have access to one of the reviewers in this bundle.
                                    </div>
                                </div>
                                <!-- End Card -->
                            </div>

                            <div class="order-1 lg:order-2">
                                <!-- Card -->
                                <div
                                    class=" shadow-xl shadow-true-gray-950 px-6 pb-4 pt-5 relative z-10 bg-true-gray-900 border border-true-gray-700 rounded-xl md:p-10">
                                    <h3 class="mt-8 sm:mt-4 md:mt-2 text-xl font-bold text-true-gray-300">Full
                                        Airman Bundle</h3>
                                    <div class="text-sm text-true-gray-500">
                                        Your complete package for the CAAP License and MTP Entrance Exam.
                                    </div>
                                    <!-- <span
                                    class="font-semibold absolute top-0 right-0 rounded-tr-xl rounded-bl-xl rounded-es-xl text-sm font-medium bg-green-500 text-white py-1.5 px-3">
                                    Best Value! Save ₱2,000!
                                </span> -->
                                    <span
                                        class="font-semibold absolute top-0 right-0 rounded-tr-xl rounded-bl-xl rounded-es-xl text-sm font-medium bg-green-500 text-white py-1.5 px-3">
                                        Best Value! Maximum Save of ₱4,000!
                                    </span>


                                    <!-- <div class="mt-5">
                                    <span class="text-6xl font-bold text-true-gray-300">
                                        ₱{{ fullAirmanBundlePrice }}
                                    </span>
                                </div> -->
                                    <div class="mt-5 flex flex-row items-end">
                                        <span class="text-4xl sm:text-6xl font-bold text-true-gray-300">₱{{
                                            fullAirmanBundlePrice }}</span>
                                    </div>

                                    <div
                                        class="mt-2 grid grid-cols-2 gap-y-2 py-4 first:pt-0 last:pb-0 sm:gap-x-6 sm:gap-y-0">
                                        <!-- List -->
                                        <ul class="space-y-2 text-sm sm:text-base">
                                            <li class="flex gap-x-3">
                                                <span
                                                    class="mt-0.5 w-5 h-5 flex justify-center items-center rounded-full bg-yellow-900 text-yellow-400">
                                                    <svg class="shrink-0 w-4 h-4" xmlns="http://www.w3.org/2000/svg"
                                                        width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                        stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                        stroke-linejoin="round">
                                                        <polyline points="20 6 9 17 4 12"></polyline>
                                                    </svg>
                                                </span>
                                                <span class="text-true-gray-300">
                                                    CAAP 101
                                                </span>
                                            </li>

                                            <li class="flex gap-x-3">
                                                <span
                                                    class="mt-0.5 w-5 h-5 flex justify-center items-center rounded-full bg-yellow-900 text-yellow-400">
                                                    <svg class="shrink-0 w-4 h-4" xmlns="http://www.w3.org/2000/svg"
                                                        width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                        stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                        stroke-linejoin="round">
                                                        <polyline points="20 6 9 17 4 12"></polyline>
                                                    </svg>
                                                </span>
                                                <span class="text-true-gray-300">
                                                    CAAP Knowledge
                                                </span>
                                            </li>
                                        </ul>
                                        <!-- End List -->

                                        <!-- List -->
                                        <ul class="space-y-2 text-sm sm:text-base">
                                            <li class="flex gap-x-3">
                                                <span
                                                    class="mt-0.5 w-5 h-5 flex justify-center items-center rounded-full bg-yellow-900 text-yellow-400">
                                                    <svg class="shrink-0 w-4 h-4" xmlns="http://www.w3.org/2000/svg"
                                                        width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                        stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                        stroke-linejoin="round">
                                                        <polyline points="20 6 9 17 4 12"></polyline>
                                                    </svg>
                                                </span>
                                                <span class="text-true-gray-300">
                                                    CAAP Practical
                                                </span>
                                            </li>

                                            <li class="flex gap-x-3">
                                                <span
                                                    class="mt-0.5 w-5 h-5 flex justify-center items-center rounded-full bg-yellow-900 text-yellow-400">
                                                    <svg class="shrink-0 w-4 h-4" xmlns="http://www.w3.org/2000/svg"
                                                        width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                        stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                        stroke-linejoin="round">
                                                        <polyline points="20 6 9 17 4 12"></polyline>
                                                    </svg>
                                                </span>
                                                <span class="text-true-gray-300">
                                                    MTP Entrance
                                                </span>
                                            </li>

                                        </ul>
                                        <!-- End List -->
                                    </div>

                                    <div
                                        class="mt-5 flex flex-col space-y-4 sm:space-y-0 sm:flex-row first:pt-0 last:pb-0">
                                        <div class="flex-1">
                                            <p class="text-sm text-true-gray-500">3-month access per
                                                reviewer.</p>
                                            <p class="text-sm text-true-gray-500">Activate anytime when
                                                you're ready to start.</p>
                                        </div>

                                        <div v-if="canPurchaseFullAirmanBundle && !isInitializing" class="sm:ml-4">
                                            <button :disabled="!canPurchaseFullAirmanBundle"
                                                @click="openPurchaseModal('Full Airman Bundle')"
                                                class="mb-3 sm:mb-0 w-full px-8 text-center whitespace-nowrap text-base rounded-md bg-yellow-400 py-3 text-base font-semibold text-black hover:bg-yellow-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-true-gray-500">
                                                Get Access
                                            </button>
                                        </div>
                                    </div>

                                    <div v-if="!canPurchaseFullAirmanBundle && !isInitializing"
                                        class="text-sm text-green-500 border border-green-500 rounded-md p-2 mt-4 text-left">
                                        You already have access to one of the reviewers in this bundle.
                                    </div>
                                </div>
                                <!-- End Card -->
                            </div>
                        </div>
                        <!-- End Grid -->

                    </div>

                    <div class="mt-12 text-center">
                        <p class="text-xs text-true-gray-500 max-w-2xl mx-auto">
                            What does <strong class="font-semibold text-true-gray-400">"Activate"</strong> mean? Your
                            reviewer's
                            duration (3 months or 1 month) only begins once you press the activate button. Buy now, lock
                            in the discounted rate, and start studying whenever you're ready.
                        </p>
                    </div>
                </div>

                <div class="w-full mt-12 py-10 lg:py-14 mx-auto">
                    <!-- Title -->
                    <div class="max-w-2xl mx-auto text-center mb-8 lg:mb-10">
                        <h2 class="text-2xl font-bold md:text-4xl md:leading-tight text-true-gray-300">
                            Individual
                        </h2>
                    </div>
                    <!-- End Title -->

                    <!-- Switch -->
                    <div class="flex justify-center items-center gap-x-3">
                        <span class="text-sm text-true-gray-500 font-semibold">1
                            Month</span>
                        <button type="button" @click="togglePricing"
                            class="relative inline-flex h-6 w-12 items-center rounded-full px-0.5 transition-colors focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2 focus:ring-offset-true-gray-900"
                            :class="is3Months ? 'bg-yellow-400' : 'bg-true-gray-700'" role="switch"
                            :aria-checked="is3Months">
                            <span
                                class="inline-block h-5 w-5 transform rounded-full bg-white shadow-xs transition-transform"
                                :class="is3Months ? 'translate-x-6' : 'translate-x-0'">
                            </span>
                        </button>
                        <span class="relative text-sm text-true-gray-500 font-semibold">
                            3 Months
                            <!-- <span class="absolute -top-10 start-auto -end-28" x-show="$store.pricing.is3Months">
        <span class="flex items-center">
          <svg class="w-14 h-8 -me-6" width="45" height="25" viewBox="0 0 45 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M43.2951 3.47877C43.8357 3.59191 44.3656 3.24541 44.4788 2.70484C44.5919 2.16427 44.2454 1.63433 43.7049 1.52119L43.2951 3.47877ZM4.63031 24.4936C4.90293 24.9739 5.51329 25.1423 5.99361 24.8697L13.8208 20.4272C14.3011 20.1546 14.4695 19.5443 14.1969 19.0639C13.9242 18.5836 13.3139 18.4152 12.8336 18.6879L5.87608 22.6367L1.92723 15.6792C1.65462 15.1989 1.04426 15.0305 0.563943 15.3031C0.0836291 15.5757 -0.0847477 16.1861 0.187863 16.6664L4.63031 24.4936ZM43.7049 1.52119C32.7389 -0.77401 23.9595 0.99522 17.3905 5.28788C10.8356 9.57127 6.58742 16.2977 4.53601 23.7341L6.46399 24.2659C8.41258 17.2023 12.4144 10.9287 18.4845 6.96211C24.5405 3.00476 32.7611 1.27399 43.2951 3.47877L43.7049 1.52119Z" fill="currentColor" class="fill-gray-300 dark:fill-neutral-700"/>
          </svg>
          <span class="mt-3 inline-block whitespace-nowrap text-[11px] leading-5 font-semibold uppercase bg-yellow-600 text-white rounded-full py-1 px-2.5">Save up to 10%</span>
        </span>
      </span> -->
                        </span>
                    </div>
                    <!-- End Switch -->

                    <!-- Grid -->
                    <div class="mt-12 grid sm:grid-cols-2 md:grid-cols-2 xl:grid-cols-4 gap-6 lg:items-center">
                        <!-- Card -->
                        <div
                            class="flex flex-col border border-true-gray-700 shadow-sm text-center rounded-xl p-4 sm:p-8 bg-true-gray-900">
                            <h4 class="font-medium text-lg text-true-gray-300">CAAP 101</h4>
                            <span class="mt-7 font-bold text-4xl sm:text-5xl text-true-gray-300">Free</span>
                            <p class="mt-2 text-sm text-true-gray-500">Forever free once you sign up.</p>

                            <ul class="mt-7 space-y-2.5 text-sm mb-4">

                                <li class="flex gap-x-2">
                                    <svg class="shrink-0 -mt-0.5 size-4 text-yellow-400"
                                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    <span class="text-true-gray-400 text-left">
                                        Step-by-step instructions on how to process
                                    </span>
                                </li>

                                <li class="flex gap-x-2">
                                    <svg class="shrink-0 -mt-0.5 size-4 text-yellow-400"
                                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    <span class="text-true-gray-400 text-left">
                                        Specially Designed for CAAP Licensure Exam
                                    </span>
                                </li>

                                <li class="flex gap-x-2">
                                    <svg class="shrink-0 -mt-0.5 size-4 text-yellow-400"
                                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    <span class="text-true-gray-400 text-left">
                                        Comes with sample pictures and documents
                                    </span>
                                </li>

                                <li class="flex gap-x-2">
                                    <svg class="shrink-0 -mt-0.5 size-4 text-yellow-400"
                                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    <span class="text-true-gray-400 text-left">
                                        Constantly being updated with the latest data
                                    </span>
                                </li>

                                <li class="flex gap-x-2">
                                    <svg class="shrink-0 -mt-0.5 size-4 text-yellow-400"
                                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    <span class="text-true-gray-400 text-left">
                                        Includes tips & strategies for a quicker study
                                    </span>
                                </li>
                            </ul>

                            <!-- <button type="button" disabled class="disabled:pointer-events-none disabled:cursor-not-allowed disabled:hover:bg-true-gray-900 mt-5 py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-lg border border-true-gray-700 bg-true-gray-900 text-true-gray-300 shadow-2xs hover:bg-true-gray-800 disabled:opacity-50 focus:outline-hidden focus:bg-true-gray-800 disabled:opacity-100">
                            Access Already Granted
                        </button> -->
                            <div class="text-sm text-green-500 border border-green-500 rounded-md p-2 mt-4 text-left">
                                You already have access to this reviewer.
                            </div>
                        </div>
                        <!-- End Card -->

                        <!-- Card -->
                        <div class="flex flex-col text-center rounded-xl p-4 sm:p-8 bg-true-gray-900"
                            :class="is3Months ? 'shadow-xl border-2 border-yellow-400' : 'border border-true-gray-700'">
                            <!-- <template x-if="$store.pricing.is3Months">
        <p class="mb-3"><span class="inline-flex items-center gap-1.5 py-1.5 px-3 rounded-lg text-xs uppercase font-semibold bg-yellow-100 text-yellow-800 dark:bg-yellow-600 dark:text-white">Highly Recommended</span></p>
      </template> -->
                            <h4 class="font-medium text-lg text-true-gray-300">CAAP Knowledge</h4>
                            <span class="mt-5 font-bold text-4xl sm:text-5xl text-true-gray-300">
                                <span class="font-bold text-2xl">₱</span>
                                <span>{{ caapKnowledgePrice }}</span>
                            </span>
                            <p class="mt-2 text-sm text-true-gray-500">
                                <span>
                                    {{ is3Months ? '3 Months duration, activate anytime.' : '1 Month duration, activate anytime.' }}
                                </span>
                            </p>



                            <ul class="mt-7 space-y-2.5 text-sm mb-4">
                                <li class="flex gap-x-2">
                                    <svg class="shrink-0 -mt-0.5 size-4 text-yellow-400"
                                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    <span class="text-true-gray-400 text-left">
                                        Most Accurate AMT &amp; AVT Reviewer Today
                                    </span>
                                </li>

                                <li class="flex gap-x-2">
                                    <svg class="shrink-0 -mt-0.5 size-4 text-yellow-400"
                                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    <span class="text-true-gray-400 text-left">
                                        Specially Designed for CAAP Licensure Exam
                                    </span>
                                </li>

                                <li class="flex gap-x-2">
                                    <svg class="shrink-0 -mt-0.5 size-4 text-yellow-400"
                                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    <span class="text-true-gray-400 text-left">
                                        7 Complete Subjects for AMT Rating License
                                    </span>
                                </li>

                                <li class="flex gap-x-2">
                                    <svg class="shrink-0 -mt-0.5 size-4 text-yellow-400"
                                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    <span class="text-true-gray-400 text-left">
                                        6 Complete Subjects for AMS Rating License
                                    </span>
                                </li>

                                <li class="flex gap-x-2">
                                    <svg class="shrink-0 -mt-0.5 size-4 text-yellow-400"
                                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    <span class="text-true-gray-400 text-left">
                                        Mock Exams w/ Time Limit and Passing Rates
                                    </span>
                                </li>

                                <li class="flex gap-x-2">
                                    <svg class="shrink-0 -mt-0.5 size-4 text-yellow-400"
                                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    <span class="text-true-gray-400 text-left">
                                        Get an Exclusive Achievement Box for Free.
                                    </span>
                                </li>
                            </ul>


                            <div v-if="!canPurchaseCAAPKnowledge && !isInitializing"
                                class="text-sm text-green-500 border border-green-500 rounded-md p-2 mt-4 text-left">
                                You already have access to this reviewer.
                            </div>
                            <div v-else>
                                <!-- Info -->
                                <div v-if="is3Months"
                                    class="text-left mb-4 border border-yellow-500 py-2 px-3 bg-yellow-900 bg-opacity-30 rounded-lg">
                                    <span class="text-left gap-1.5 text-sm text-yellow-300">
                                        Also available in 1 Month duration at ₱{{ getFormattedPrice('CAAP Knowledge',
                                            false)
                                        }}. Click <a href="#" @click="togglePricing" class="underline">here</a> to
                                        switch.
                                    </span>
                                </div>
                                <div v-else-if="!is3Months"
                                    class="text-left mb-4 border border-yellow-500 py-2 px-3 rounded-lg bg-yellow-900 bg-opacity-30">
                                    <span class="text-left gap-1.5 text-sm text-yellow-300">
                                        Also available in 3 Months duration at ₱{{ getFormattedPrice('CAAP Knowledge',
                                            true)
                                        }}. Click <a href="#" @click="togglePricing" class="underline">here</a> to
                                        switch.
                                    </span>
                                </div>

                                <!-- <button :disabled="!canPurchaseCAAPKnowledge" class="
                                w-full 
                                mt-5 py-3 px-4 inline-flex justify-center items-center 
                                gap-x-2 text-sm font-medium rounded-lg border border-transparent 
                                bg-yellow-400 font-semibold text-black 
                                hover:bg-yellow-500 focus:outline-hidden focus:bg-yellow-500 
                                disabled:opacity-50 disabled:pointer-events-none disabled:cursor-not-allowed"
                                @click="openPurchaseModal('CAAP Knowledge')">
                                Get Access
                            </button> -->
                                <button :disabled="!canPurchaseCAAPKnowledge"
                                    @click="openPurchaseModal('CAAP Knowledge')"
                                    class="w-full text-center whitespace-nowrap text-base rounded-md bg-yellow-400 py-3 text-base font-semibold text-black hover:bg-yellow-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-true-gray-500">
                                    Get Access
                                </button>
                            </div>
                        </div>
                        <!-- End Card -->

                        <!-- Card -->
                        <div
                            class="flex flex-col border border-true-gray-700 shadow-sm text-center rounded-xl p-4 sm:p-8 bg-true-gray-900">
                            <h4 class="font-medium text-lg text-true-gray-300">CAAP Practical</h4>
                            <span v-if="isAvailableForDuration('CAAP Practical', is3Months)"
                                class="mt-5 font-bold text-4xl sm:text-5xl text-true-gray-300">
                                <span class="font-bold text-2xl">₱</span>
                                <span>{{ caapPracticalPrice }}</span>
                            </span>
                            <span v-else class="mt-5 font-bold text-3xl sm:text-4xl text-true-gray-300">
                                Unavailable
                            </span>
                            <p class="mt-2 text-sm text-true-gray-500">
                                <span>
                                    {{ is3Months ? '3 Months duration, activate anytime.' : 'This is only available in 3 Months duration.' }}
                                </span>
                            </p>


                            <ul class="mt-7 space-y-2.5 text-sm mb-4">
                                <li class="flex gap-x-2">
                                    <svg class="shrink-0 -mt-0.5 size-4 text-yellow-400"
                                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    <span class="text-true-gray-400 text-left">
                                        Designed for CAAP Practical Exam (Skill Test)
                                    </span>
                                </li>

                                <li class="flex gap-x-2">
                                    <svg class="shrink-0 -mt-0.5 size-4 text-yellow-400"
                                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    <span class="text-true-gray-400 text-left">
                                        Applicable for both AMT &amp; AVT
                                    </span>
                                </li>

                                <li class="flex gap-x-2">
                                    <svg class="shrink-0 -mt-0.5 size-4 text-yellow-400"
                                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    <span class="text-true-gray-400 text-left">
                                        Real Pictures Included for Faster Learning
                                    </span>
                                </li>

                                <li class="flex gap-x-2">
                                    <svg class="shrink-0 -mt-0.5 size-4 text-yellow-400"
                                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    <span class="text-true-gray-400 text-left">
                                        Sorted By Exam Types for Easier Review
                                    </span>
                                </li>

                                <li class="flex gap-x-2">
                                    <svg class="shrink-0 -mt-0.5 size-4 text-yellow-400"
                                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    <span class="text-true-gray-400 text-left">
                                        Comes in Study and Exam Mode
                                    </span>
                                </li>
                            </ul>


                            <div v-if="!canPurchaseCAAPPractical && !isInitializing"
                                class="text-sm text-green-500 border border-green-500 rounded-md p-2 mt-4 text-left">
                                You already have access to this reviewer.
                            </div>
                            <div v-else>
                                <button :disabled="!canPurchaseCAAPPractical" v-if="is3Months"
                                    @click="openPurchaseModal('CAAP Practical')"
                                    class="w-full text-center whitespace-nowrap text-base rounded-md py-3 text-base font-semibold text-true-gray-300 border border-true-gray-700  hover:bg-true-gray-800 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-true-gray-500">
                                    Get Access
                                </button>
                                <div v-else
                                    class="mt-5 py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-lg border border-true-gray-700 bg-true-gray-900 text-true-gray-300 shadow-2xs hover:bg-true-gray-800 disabled:opacity-50 disabled:pointer-events-none focus:outline-hidden focus:bg-true-gray-800">
                                    <p>
                                        This is only available in 3 Months duration.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- End Card -->

                        <!-- Card -->
                        <div
                            class="flex flex-col border border-true-gray-700 shadow-sm text-center rounded-xl p-4 sm:p-8 bg-true-gray-900">
                            <h4 class="font-medium text-lg text-true-gray-300">MTP Entrance</h4>
                            <span v-if="isAvailableForDuration('MTP Entrance', is3Months)"
                                class="mt-5 font-bold text-4xl sm:text-5xl text-true-gray-300">
                                <span class="font-bold text-2xl">₱</span>
                                <span>{{ entranceExamPrice }}</span>
                            </span>
                            <span v-else class="mt-5 font-bold text-3xl sm:text-4xl text-true-gray-300">
                                Unavailable
                            </span>
                            <p class="mt-2 text-sm text-true-gray-500">
                                <span>
                                    {{ is3Months ? '3 Months duration, activate anytime.' : 'This is only available in 3 Months duration.' }}
                                </span>
                            </p>


                            <ul class="mt-7 space-y-2.5 text-sm mb-4">
                                <li class="flex gap-x-2">
                                    <svg class="shrink-0 -mt-0.5 size-4 text-yellow-400"
                                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    <span class="text-true-gray-400 text-left">
                                        Designed for MTP Entrance
                                    </span>
                                </li>

                                <li class="flex gap-x-2">
                                    <svg class="shrink-0 -mt-0.5 size-4 text-yellow-400"
                                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    <span class="text-true-gray-400 text-left">
                                        Streamlined Aviation-specific Subjects
                                    </span>
                                </li>

                                <li class="flex gap-x-2">
                                    <svg class="shrink-0 -mt-0.5 size-4 text-yellow-400"
                                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    <span class="text-true-gray-400 text-left">
                                        Specially Selected Logic Tests Included
                                    </span>
                                </li>

                                <li class="flex gap-x-2">
                                    <svg class="shrink-0 -mt-0.5 size-4 text-yellow-400"
                                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    <span class="text-true-gray-400 text-left">
                                        Quick Tips and Strategies for MANDEX
                                    </span>
                                </li>

                                <li class="flex gap-x-2">
                                    <svg class="shrink-0 -mt-0.5 size-4 text-yellow-400"
                                        xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    <span class="text-true-gray-400 text-left">
                                        Comes with Optimized Mock Exams
                                    </span>
                                </li>

                            </ul>



                            <div v-if="!canPurchaseEntranceExam && !isInitializing"
                                class="text-sm text-green-500 border border-green-500 rounded-md p-2 mt-4 text-left">
                                You already have access to this reviewer.
                            </div>
                            <div v-else>
                                <button :disabled="!canPurchaseEntranceExam" v-if="is3Months"
                                    @click="openPurchaseModal('MTP Entrance')"
                                    class="w-full text-center whitespace-nowrap text-base rounded-md py-3 text-base font-semibold text-true-gray-300 border border-true-gray-700  hover:bg-true-gray-800 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-true-gray-500">
                                    Get Access
                                </button>
                                <div v-else
                                    class="mt-5 py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-lg border border-true-gray-700 bg-true-gray-900 text-true-gray-300 shadow-2xs hover:bg-true-gray-800 disabled:opacity-50 disabled:pointer-events-none focus:outline-hidden focus:bg-true-gray-800">
                                    <p>
                                        This is only available in 3 Months duration.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- End Card -->
                    </div>
                    <!-- End Grid -->
                </div>
                <PurchaseModal :isPurchaseModalOpen="isPurchaseModalOpen" :user="userInfo"
                    :selectedPurchase="selectedPurchase" :selectedPricing="selectedPricing"
                    @closePurchaseModal="closePurchaseModal" />
            </div>
        </div>

    </div>
</template>
<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
// Firebase
import { auth, db } from "@/firebase/config";
import { doc, getDoc } from "firebase/firestore";

import PurchaseModal from './components/PurchaseModal.vue'
import { PRICING } from './helpers/data.js'
import { trackPurchaseButtonClick } from '@/utils/analytics'

const router = useRouter()
const route = useRoute()
const userInfo = ref(null)
const isAdminPurchase = computed(() => {
    return !!route.query.userId
})
// Pricing toggle state - defaults to 3 months (true)
const is3Months = ref(true)
const isPurchaseModalOpen = ref(false)
const selectedPurchase = ref(null)
const selectedPricing = ref(null)

// Map purchase names to PRICING keys
const purchaseToPricingKey = {
    'CAAP License Bundle': 'full-license-bundle',
    'Full Airman Bundle': 'full-airman-bundle',
    'CAAP Knowledge': 'caap-knowledge',
    'CAAP Practical': 'caap-practical',
    'MTP Entrance': 'entrance-exam',
}

// Helper function to get price for a purchase
const getPrice = (purchaseName, isThreeMonths = true) => {
    const pricingKey = purchaseToPricingKey[purchaseName]
    if (!pricingKey || !PRICING[pricingKey]) return null

    const pricing = PRICING[pricingKey]
    const targetDuration = isThreeMonths ? 90 : 30
    const durationOption = pricing.durations.find(d => d.duration === targetDuration)

    return durationOption ? durationOption.price : null
}

const isInitializing = ref(true)
onMounted(async () => {
    isInitializing.value = true
    console.log('%c Reviewers page mounted', 'color: yellow; font-weight: bold;');
    userInfo.value = await fetchUserInfo();
    //   initializeUI(userInfo.value);
    isInitializing.value = false
});

/**
 * Get the user data or information form database.
 * This is a promise.
 * If userId query param exists, fetch that user instead of current user (admin purchase mode).
 */

const fetchUserInfo = async () => {
    // Check if we're in admin purchase mode (userId query param exists)
    const targetUserId = route.query.userId;
    const userIdToFetch = targetUserId || auth.currentUser.uid;

    try {
        const userDocRef = doc(db, "users", userIdToFetch);
        const userDocSnap = await getDoc(userDocRef);

        if (!userDocSnap.exists()) {
            throw new Error(`User document not found for ID: ${userIdToFetch}`);
        }

        let data = userDocSnap.data();
        data.id = userDocSnap.id;
        return data;
    } catch (error) {
        console.error("Error getting user document:", error);
        throw `Error getting user document: ${error}`;
    }
};

// Helper function to format price
const formatPrice = (price) => {
    if (price === null) return 'Unavailable'
    return price.toLocaleString()
}

// Helper function to get and format price (for template use)
const getFormattedPrice = (purchaseName, isThreeMonths = true) => {
    const price = getPrice(purchaseName, isThreeMonths)
    if (price === null) return 'N/A'
    return price.toLocaleString()
}

// Computed prices for bundles (bundles only have 3-month option)
const caapLicenseBundlePrice = computed(() => {
    const price = getPrice('CAAP License Bundle', true) // Always 3 months
    return formatPrice(price)
})

const fullAirmanBundlePrice = computed(() => {
    const price = getPrice('Full Airman Bundle', true) // Always 3 months
    return formatPrice(price)
})

// Computed prices for individual reviewers
const caapKnowledgePrice = computed(() => {
    const price = getPrice('CAAP Knowledge', is3Months.value)
    return formatPrice(price)
})

const caapPracticalPrice = computed(() => {
    const price = getPrice('CAAP Practical', is3Months.value)
    return formatPrice(price)
})

const entranceExamPrice = computed(() => {
    const price = getPrice('MTP Entrance', is3Months.value)
    return formatPrice(price)
})

const canPurchaseFullLicenseBundle = computed(() => {
    return userInfo.value && userInfo.value.reviewers && userInfo.value.reviewers.caap === 'inactive' && userInfo.value.reviewers.caap_plus === 'inactive'
})

const canPurchaseFullAirmanBundle = computed(() => {
    return userInfo.value && userInfo.value.reviewers && userInfo.value.reviewers.caap === 'inactive' && userInfo.value.reviewers.caap_plus === 'inactive' && userInfo.value.reviewers.mtp === 'inactive'
})

const canPurchaseCAAPKnowledge = computed(() => {
    return userInfo.value && userInfo.value.reviewers && userInfo.value.reviewers.caap === 'inactive'
})

const canPurchaseCAAPPractical = computed(() => {
    return userInfo.value && userInfo.value.reviewers && userInfo.value.reviewers.caap_plus === 'inactive'
})

const canPurchaseEntranceExam = computed(() => {
    return userInfo.value && userInfo.value.reviewers && userInfo.value.reviewers.mtp === 'inactive'
})

// Helper to check if a purchase is available for a duration
const isAvailableForDuration = (purchaseName, isThreeMonths = true) => {
    const pricingKey = purchaseToPricingKey[purchaseName]
    if (!pricingKey || !PRICING[pricingKey]) return false

    const pricing = PRICING[pricingKey]
    const targetDuration = isThreeMonths ? 90 : 30
    return pricing.durations.some(d => d.duration === targetDuration)
}

// Helper to get pricing data for modal with selected duration
const getPricingData = (purchaseName, isThreeMonths = true) => {
    const pricingKey = purchaseToPricingKey[purchaseName]
    if (!pricingKey || !PRICING[pricingKey]) return null

    const pricing = PRICING[pricingKey]
    const targetDuration = isThreeMonths ? 90 : 30
    const selectedDurationOption = pricing.durations.find(d => d.duration === targetDuration)

    if (!selectedDurationOption) return null

    return {
        key: pricingKey,
        selectedDuration: selectedDurationOption,
        availableDurations: pricing.durations // Keep all durations for reference if needed
    }
}

// Toggle function
const togglePricing = () => {
    is3Months.value = !is3Months.value
}

const navigateTo = (path) => {
    router.push(path)
}

const handleBackNavigation = () => {
    if (isAdminPurchase.value) {
        // Navigate back to users-v2 page
        router.push('/v2/users-v2')
    } else {
        // Navigate to reviewers page (existing behavior)
        navigateTo('/reviewers')
    }
}

const openPurchaseModal = (purchase) => {
    isPurchaseModalOpen.value = true
    selectedPurchase.value = purchase
    // Bundles only have 3-month option, individual reviewers use the toggle state
    const isBundle = purchase === 'CAAP License Bundle' || purchase === 'Full Airman Bundle'
    const durationToUse = isBundle ? true : is3Months.value
    selectedPricing.value = getPricingData(purchase, durationToUse)

    // Track button click
    if (selectedPricing.value && selectedPricing.value.selectedDuration) {
        const pricingKey = purchaseToPricingKey[purchase]
        const purchaseType = isBundle ? 'bundle' : 'individual'
        const price = selectedPricing.value.selectedDuration.price
        const duration = selectedPricing.value.selectedDuration.duration

        trackPurchaseButtonClick(
            purchaseType,
            purchase,
            pricingKey,
            price,
            duration
        )
    }
}

const closePurchaseModal = () => {
    isPurchaseModalOpen.value = false
    selectedPurchase.value = null
    selectedPricing.value = null

}


</script>